import * as React from 'react';

function createContext(t){const r=/*#__PURE__*/React.createContext(null);function n(t){const{children:n,...o}=t,u=React.useMemo((()=>o),Object.values(o));return React.createElement(r.Provider,{value:u},n)}return n.displayName=t+"Provider",[n,function(n){const o=React.useContext(r);if(null===o)throw new Error(`\`${n}\` must be used within \`${t}\``);return o}]}

export { createContext };
